/* SWÆT theme JS */
(function () {
  'use strict';

  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Hero slideshow
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-slide]');
    var dots = hero.querySelectorAll('[data-dot]');
    var progress = hero.querySelector('.hero-progress i');
    var reduceHero = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function applyAccent(slide) {
      var a = slide && slide.getAttribute('data-accent');
      if (a) hero.style.setProperty('--hero-accent', a);
    }
    function restartProgress() {
      if (!progress || reduceHero) return;
      progress.classList.remove('run');
      void progress.offsetWidth; // reflow to restart animation
      progress.classList.add('run');
    }
    applyAccent(slides[0]);
    if (slides.length < 2) return;

    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { d.classList.toggle('is-active', x === i); });
      applyAccent(slides[i]);
      restartProgress();
    }
    function next() { go(i + 1); }
    function start() { if (!reduceHero) { timer = setInterval(next, 6000); restartProgress(); } }
    function stop() { clearInterval(timer); }

    var prev = hero.querySelector('[data-prev]');
    var nxt = hero.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(i - 1); start(); });
    if (nxt) nxt.addEventListener('click', function () { stop(); next(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { stop(); go(parseInt(d.dataset.dot, 10)); start(); });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    // Mouse parallax: bottle bg vs text drift in opposite directions
    if (!reduceHero && window.matchMedia('(pointer:fine)').matches) {
      hero.addEventListener('mousemove', function (ev) {
        var r = hero.getBoundingClientRect();
        var dx = (ev.clientX - r.left) / r.width - 0.5;
        var dy = (ev.clientY - r.top) / r.height - 0.5;
        var bg = hero.querySelector('.hero-slide.is-active .hero-slide__bg');
        var content = hero.querySelector('.hero-slide.is-active .hero-slide__content');
        if (bg) bg.style.transform = 'scale(1.06) translate(' + (dx * 18) + 'px,' + (dy * 14) + 'px)';
        if (content) content.style.transform = 'translate(' + (dx * -12) + 'px,' + (dy * -8) + 'px)';
      });
      hero.addEventListener('mouseleave', function () {
        var bg = hero.querySelector('.hero-slide.is-active .hero-slide__bg');
        var content = hero.querySelector('.hero-slide.is-active .hero-slide__content');
        if (bg) bg.style.transform = '';
        if (content) content.style.transform = '';
      });
    }

    start();
  });

  // Quantity steppers
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('[data-qty-input]');
    var minus = q.querySelector('[data-qty-minus]');
    var plus = q.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;
    minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // AJAX add-to-cart for product cards (keeps shopper on page)
  document.querySelectorAll('.pcard__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(new FormData(form))
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
        })
        .catch(function () { btn.textContent = label; btn.disabled = false; window.location.href = '/cart'; });
    });
  });
})();

/* ===== v2 motion ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    document.querySelectorAll('[data-reveal],[data-stagger]').forEach(function (el) { el.classList.add('in'); });
    return;
  }

  // Scroll reveal
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-reveal],[data-stagger]').forEach(function (el) { io.observe(el); });

  // Animated counters
  function animateCount(el) {
    var target = parseFloat(el.dataset.count);
    var suffix = el.dataset.suffix || '';
    var dec = (el.dataset.count.indexOf('.') > -1) ? 1 : 0;
    var dur = 1400, start = performance.now();
    function tick(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = target.toFixed(dec) + suffix;
    }
    requestAnimationFrame(tick);
  }
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { animateCount(e.target); cio.unobserve(e.target); }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

  // Card 3D tilt
  document.querySelectorAll('.pcard').forEach(function (card) {
    var raf;
    card.addEventListener('mousemove', function (ev) {
      var r = card.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width - 0.5;
      var y = (ev.clientY - r.top) / r.height - 0.5;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.transform = 'translateY(-6px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg)';
      });
    });
    card.addEventListener('mouseleave', function () {
      cancelAnimationFrame(raf);
      card.style.transform = '';
    });
  });

  // Hero subtle parallax on bg
  var hero = document.querySelector('[data-hero]');
  if (hero) {
    window.addEventListener('scroll', function () {
      var bg = hero.querySelector('.hero-slide.is-active .hero-slide__bg');
      if (!bg) return;
      var y = Math.min(window.scrollY, 600);
      bg.style.transform = 'translateY(' + (y * 0.18) + 'px) scale(1.05)';
    }, { passive: true });
  }
})();

/* ===== v5 — product image carousel ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-pcarousel]').forEach(function (car) {
    var slides = car.querySelectorAll('[data-pslide]');
    var dots = car.querySelectorAll('[data-pdot]');
    var thumbs = car.querySelectorAll('[data-pthumb]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var autoplay = car.getAttribute('data-autoplay') !== 'false';
    var interval = parseInt(car.getAttribute('data-interval'), 10) || 4000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { d.classList.toggle('is-active', x === i); });
      thumbs.forEach(function (t, x) {
        var on = x === i;
        t.classList.toggle('is-active', on);
        if (on) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }
    function next() { show(i + 1); }
    function start() { if (autoplay && !reduce) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var prev = car.querySelector('[data-pprev]');
    var nxt = car.querySelector('[data-pnext]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (nxt) nxt.addEventListener('click', function () { next(); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.pdot, 10)); start(); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.pthumb, 10)); start(); }); });

    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);

    // Swipe on touch
    var x0 = null;
    car.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    car.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : show(i - 1); }
      x0 = null; start();
    }, { passive: true });

    start();
  });
})();
